import { call, put, takeEvery } from 'redux-saga/effects'
import API from '../../API';
import history from '../../common/history';


import { setAuth, setIncompleteRegAuth } from '../../utils';
import { toastr } from 'react-redux-toastr';
import axiosInstance from '../../common/api/axiosConfig';
import Cookies from 'js-cookie';

async function postApi(data) {
    try {
        const response = axiosInstance.post('/auth/sign_in.json', data)
        return await response;
    } catch (error) {
        throw error;
    }
}

function* login(action) {
    try {
        const auth = yield call(postApi, action.data);
        
        // Check if user has verified their OTP during registration
        if (auth.data.verification_status === false) {
            // User hasn't verified OTP, redirect to OTP verification page
            setIncompleteRegAuth(auth.data.data, auth.headers);
            
            // Store user email in cookies for OTP verification
            // Try to get email from multiple sources
            const emailToSet = action.data.email || auth.data.data?.email || auth.data.email || auth.data.data?.user?.email;
            
            console.log('Login Saga - Setting email for OTP:', emailToSet);
            console.log('Login Saga - Action data:', action.data);
            console.log('Login Saga - Auth data:', auth.data);
            
            if (emailToSet) {
                Cookies.set('email', emailToSet);
            } else {
                console.warn('Login Saga - No email found to set for OTP verification');
            }
            
            window.location.href = '/otp';
            return;
        }
        
        // If verification_status is true or not present, proceed with normal login flow
        if (auth.data.signup_status && auth.data.signup_status === "completed") {
            setAuth(auth.data.data, auth.headers);
            history.push('/dashboard');
            window.location.reload();
        } else if (auth.data.signup_status && auth.data.signup_status === "verification_status") {
            // This case should now be handled above, but keeping for safety
            setAuth(auth.data.data, auth.headers);
            history.push('/dashboard');
            window.location.reload();
        } else {
            // setIncompleteRegAuth(auth.data.data, auth.headers);
            // yield put({ type: 'STORE_ACTIVE_REG_STEP_SUCCESS', activeStep: auth.data.signup_status == "business-info" ? 3 : 5 });
            // history.push('/register');
            // window.location.reload();
            setAuth(auth.data.data, auth.headers);
            history.push('/dashboard');
            window.location.reload();
        }
    } catch (e) {
        // toastr.error('Login failed', 'Sorry unable to login successfully');
        yield put({ type: 'POST_LOGIN_FAILED', message: e.response.data.errors[0] });
    }
}

function* loginSaga() {
    yield takeEvery('POST_LOGIN_REQUESTED', login);
}

export default loginSaga;